














import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'AuthPage'
})
export default class AuthPage extends Vue {}
